import RestService from './RestService';

export default class AssessmentTemplatesService extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/assessment-templates`);
        } else super('/assessment-templates');
    }

    all() {
        return this.get(`${this.baseUrl}/all`);
    }

    superGet(id) {
        return this.get(`${this.baseUrl}/all/${id}`);
    }

    superGetQuestions(id) {
        return this.get(`${this.baseUrl}/all/${id}/questions`);
    }

    addQuestion(templateId, questionId) {
        return this.post(`${this.baseUrl}/${templateId}/questions`, {
            questionId,
        });
    }

    deleteQuestion(templateId, questionId) {
        return this.del(`${this.baseUrl}/${templateId}/questions/${questionId}`);
    }

    update(templateId, values) {
        return this.put(`${this.baseUrl}/${templateId}`, values);
    }

    create(values) {
        return this.post(`${this.baseUrl}`, values);
    }
}

